import Toaster from 'components/shared/toaster/toaster';
import React, { lazy, Suspense, useEffect } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { initInterceptors } from './interceptors/login.interceptor';
import sessionStorageCopy from './utils/sessionStorageSync';

const Login = lazy(() => import('pages/login'));
const Wrapper = lazy(() => import('components/shared/wrapper/wrapper'));
const LoginSuccess = lazy(() => import('pages/login-success'));
const Usernotfound = lazy(() => import('pages/user-not-found'));
const ResetPassword = lazy(() => import('pages/reset-password'));

export default function App(t: Function) {
  initInterceptors();

  useEffect(() => {
    sessionStorageCopy.backupSessionStorage();

    const hostname = window.location.hostname;

    if (hostname.includes('heliopre')) {
      document.body.className = 'PRE';
    } else if (hostname.includes('heliotest')) {
      document.body.className = 'TEST';
    } else {
      document.body.className = '';
    }

    return () => {
      sessionStorageCopy.destroy();
    };
  }, []);

  return (
    <Suspense fallback={<div className="axpo-spinner"></div>}>
      <Toaster />
      <BrowserRouter>
        <Switch>
          <Route exact path="/login/:error?" component={Login} />
          <Route exact path="/loginSuccess" component={LoginSuccess} />
          <Route exact path="/userNotFound" component={Usernotfound} />
          <Route exact path="/account/reset/:key?" component={ResetPassword} />
          <Route path="/" component={Wrapper} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}
